export default "__VITE_ASSET__Biuwi5lo__"